'use client';

import { c as _c } from "react/compiler-runtime";
import { useViewport } from '@lib/tools/hooks/useViewport';
import { Placemark } from '@pbe/react-yandex-maps';
import cn from 'classnames';
import { useState } from 'react';
import style from './LocationPlacemark.module.scss';
export const LocationPlacemark = t0 => {
  const $ = _c(34);
  const {
    el,
    ymaps,
    activePlacemarkRef
  } = t0;
  const {
    isMobile,
    isTablet
  } = useViewport();
  const [activePlacemark, setActivePlacemark] = useState(null);
  let t1;
  if ($[0] !== activePlacemarkRef) {
    t1 = e => {
      const placemark = e.get("target");
      activePlacemarkRef.current = placemark;
    };
    $[0] = activePlacemarkRef;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onPlacemarkClick = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e_0 => {
      const placemark_0 = e_0.get("target");
      placemark_0.properties.set("balloonContent", `${placemark_0.properties.get("balloonContent")}`);
      placemark_0.balloon.open();
      setActivePlacemark(placemark_0.geometry.getCoordinates());
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onPlacemarkMouseEnter = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = e_1 => {
      e_1.get("target").balloon.close();
      setActivePlacemark(null);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onPlacemarkMouseLeave = t3;
  let t4;
  if ($[4] !== ymaps?.templateLayoutFactory) {
    t4 = ymaps?.templateLayoutFactory.createClass(`
    <div class="${style.balloonContentBody}">
      <div class="${style.balloonContent}">{{ properties.balloonContent|raw }}</div>
    </div>
`);
    $[4] = ymaps?.templateLayoutFactory;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const BalloonContentBodyLayout = t4;
  let t5;
  if ($[6] !== ymaps?.templateLayoutFactory) {
    t5 = ymaps?.templateLayoutFactory.createClass(`
    <div class="${style.balloon}">
      <div class="${style.balloonArrow}"></div>
      <div class="${style.balloonContentBody}">
        <div class="${style.balloonContent}">{{ properties.balloonContent|raw }}</div>
      </div>
    </div>
`);
    $[6] = ymaps?.templateLayoutFactory;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const BalloonLayout = t5;
  let t6;
  if ($[8] !== ymaps?.templateLayoutFactory) {
    t6 = (icon, additionalClass) => ymaps?.templateLayoutFactory.createClass(`<div class="${cn(style.icon, additionalClass)}" style="cursor: pointer;">
      <img src=${icon.src} style="cursor: pointer;" />
     </div>`);
    $[8] = ymaps?.templateLayoutFactory;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const createMyIconLayout = t6;
  const t7 = el.id;
  const t8 = !isMobile && !isTablet ? onPlacemarkMouseEnter : null;
  const t9 = !isMobile && !isTablet ? onPlacemarkMouseLeave : null;
  const t10 = isMobile || isTablet ? onPlacemarkClick : null;
  const t11 = el.coordinates;
  let t12;
  if ($[10] !== el.title) {
    t12 = {
      balloonContent: el.title
    };
    $[10] = el.title;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== activePlacemark || $[13] !== el.coordinates) {
    t13 = activePlacemark && activePlacemark.toString() === el.coordinates.toString() ? style.hover : "";
    $[12] = activePlacemark;
    $[13] = el.coordinates;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== createMyIconLayout || $[16] !== el.blackIcon || $[17] !== t13) {
    t14 = createMyIconLayout(el.blackIcon, t13);
    $[15] = createMyIconLayout;
    $[16] = el.blackIcon;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      type: "Circle",
      coordinates: [20, 20],
      radius: 20,
      color: "green"
    };
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = [20, -60];
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  const t17 = isMobile || isTablet ? true : false;
  let t18;
  if ($[21] !== BalloonContentBodyLayout || $[22] !== BalloonLayout || $[23] !== t14 || $[24] !== t17) {
    t18 = {
      iconLayout: t14,
      iconShape: t15,
      cursor: "pointer",
      balloonOpenTimeout: 1,
      hideIconOnBalloonOpen: false,
      balloonContentBodyLayout: BalloonContentBodyLayout,
      balloonLayout: BalloonLayout,
      balloonOffset: t16,
      zIndex: 1,
      openBalloonOnClick: t17
    };
    $[21] = BalloonContentBodyLayout;
    $[22] = BalloonLayout;
    $[23] = t14;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== el.coordinates || $[27] !== el.id || $[28] !== t10 || $[29] !== t12 || $[30] !== t18 || $[31] !== t8 || $[32] !== t9) {
    t19 = <Placemark key={t7} onMouseEnter={t8} onMouseLeave={t9} onClick={t10} geometry={t11} properties={t12} options={t18} />;
    $[26] = el.coordinates;
    $[27] = el.id;
    $[28] = t10;
    $[29] = t12;
    $[30] = t18;
    $[31] = t8;
    $[32] = t9;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  return t19;
};